import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '奶粉辅食', href: '/category/milk-powder' },
    { label: '纸尿裤湿巾', href: '/category/diapers' },
    { label: '玩具益智', href: '/category/toys' },
    { label: '童装童鞋', href: '/category/kids-clothing' },
    { label: '喂养用品', href: '/category/feeding' },
    { label: '洗护用品', href: '/category/baby-care' },
  ],
  about: [
    { label: '品牌介绍', href: '/about' },
    { label: '品牌荣誉', href: '/about#honors' },
    { label: '联系我们', href: '/about#contact' },
  ],
  articles: [
    { label: '育儿知识', href: '/articles' },
    { label: '辅食食谱', href: '/articles?tag=recipe' },
    { label: '宝宝健康', href: '/articles?tag=health' },
    { label: '妈妈护理', href: '/articles?tag=mom-care' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                蜜芽
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              蜜芽是中国领先的母婴跨境电商平台，汇聚全球优质母婴品牌，为中国家庭提供安全、正品、高性价比的母婴商品。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">商品分类</h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于蜜芽</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">育儿知识</h4>
            <ul className="space-y-2">
              {footerLinks.articles.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 蜜芽母婴跨境电商平台 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">用户协议</a>
            <span>ICP备12345678号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}